import { Row, Col, Card, Button } from 'react-bootstrap';

interface VehicleData {
  ID: number;
  VehicleRegistrationNumber: string;
  CrmClientID: string;
  Name: string;
  PhoneNumber: string;
  Email: string;
  EmployeeNumber: string;
  LeadType: string;
  RcData: string;
  InsertDateTime: string;
}

interface RcDetails {
  owner?: string;
  makerDescription?: string;
  category?: string;
  insuranceProvider?: string;
  insurancePolicyNumber?: string;
  insuranceUpto?: string;
}

type Props = {
  vehicles: VehicleData[];
  onAddVehicle: () => void;
};

const VehicleList: React.FC<Props> = ({ vehicles, onAddVehicle }) => {
  const parseRcData = (rcDataString: string): RcDetails => {
    try {
      return JSON.parse(rcDataString);
    } catch {
      return {};
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h6 className="mb-0">Your Vehicles ({vehicles.length})</h6>
        <Button variant="primary" size="sm" onClick={onAddVehicle}>
          + Add Vehicle
        </Button>
      </div>
      <Row>
        {vehicles.map((vehicle) => {
          const rcDetails = parseRcData(vehicle.RcData);
          return (
            <Col md={12} key={vehicle.ID} className="mb-4">
              <Card className="shadow-sm border-0">
                <Card.Header className="bg-primary text-white">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">{vehicle.VehicleRegistrationNumber}</h5>
                    <span className="badge bg-light text-dark">{rcDetails.category || 'N/A'}</span>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <h6 className="text-muted mb-3">Owner Information</h6>
                      <p className="mb-2"><strong>Owner:</strong> {rcDetails.owner || 'N/A'}</p>
                      <p className="mb-2"><strong>Name:</strong> {vehicle.Name}</p>
                      <p className="mb-2"><strong>Phone:</strong> {vehicle.PhoneNumber}</p>
                      <p className="mb-2"><strong>Email:</strong> {vehicle.Email}</p>
                    </Col>
                    <Col md={6}>
                      <h6 className="text-muted mb-3">Vehicle & Insurance Details</h6>
                      <p className="mb-2"><strong>Maker:</strong> {rcDetails.makerDescription || 'N/A'}</p>
                      <p className="mb-2"><strong>Insurance Provider:</strong> {rcDetails.insuranceProvider || 'Not Available'}</p>
                      <p className="mb-2"><strong>Policy Number:</strong> {rcDetails.insurancePolicyNumber || 'N/A'}</p>
                      <p className="mb-2"><strong>Insurance Valid Upto:</strong> {rcDetails.insuranceUpto && rcDetails.insuranceUpto !== '1800-01-01' ? new Date(rcDetails.insuranceUpto).toLocaleDateString() : 'Not Available'}</p>
                    </Col>
                  </Row>
                  <hr />
                  <p className="mb-0 text-muted small">Added: {new Date(vehicle.InsertDateTime).toLocaleDateString()}</p>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export { VehicleList };
export type { VehicleData };
